import { gql } from '@apollo/client';

export const deleteExtendUserHosts = gql`
  mutation deleteExtendUserHosts($deleteExtendUserHostsInput: DeleteExtendUserHostsInput) {
    deleteExtendUserHosts(input: $deleteExtendUserHostsInput) {
      altId
    }
  }
`;
